import { localCache } from "@overrides/utilities";
import { type CacheKey, cacheKey } from "./cache-key";

export const shopTokenCache = localCache<CacheKey>({
  prefix: "shop-token-cache",
  cacheKey,
  maxItems: 60,
});
